<!-- GAteway Command Modal-->
<template>
    <b-modal
      :visible="visible" 
      @hidden="hide" 
      @change="change"
      @show="fillModal"
      :hide-footer="footer_hide"
      ok-only
      ref="modal"
      id="modal-gateway-command"
      :addCu="addCu"
      :title="$t('gateway_command_modal.title')"
      :ok-title="$t('gateway_command_modal.send')"
      :cancel-title="$t('gateway_command_modal.cancel')"
      @ok="sendGatewayCommand"
    >
     
      <b-row>
        <!-- <b-col sm="3" class="text-center pt-3">
          <b-form-checkbox switch size="lg" v-model="sw">{{sw==true?"On":"Off"}}</b-form-checkbox>         
        </b-col> -->
        <b-col sm="12" class="text-center pt-3">
          <div class="typo-title">{{$t('gateway_command_modal.dimming')}}</div>  
          <vue-slider class="p-3"
          v-model="powerSet"
          :adsorb="true"
          :interval="10"
          :marks="true"
          ></vue-slider>
        </b-col>
      </b-row>
    </b-modal>
</template>

<script>
import { mapState } from "vuex";
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/default.css';

export default {
  components: {
    VueSlider
  },
  name: "GatewayCommand",
  model: {
    prop: "visible",
    event: "change"
  },
  props: {
    cu: {
      default: null
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      cuSerial: "",
      cuType: "",
      cuDesc:"",
      addCu: "false",
      confirm: 0,
      response_seen: false,
      error_seen: false,
      footer_hide: false,
      confirm_seen: false,
      form_seen: true,
      reset_error: null,
      reset_response: null,
      spinner: false,
      plantUnits: this.$store.state.plantUnits,
      timerTimeout: 5,
      powerSet:0,
      dimming:0,
      sw:null

    };

    
  },
 
  methods: {
    hide() {
      this.$emit("hide");
    },
    change(visible) {
      this.$emit("change", visible);
    },
    fillModal() {
      this.cuType="";
      this.cuSerial="";
      this.cuDesc="";
      if(this.cu)
      {
        this.cuType=this.cu.cu_type;
        this.cuSerial=this.cu.cu_id;
        this.cuDesc=this.cu.cu_desc;
      }
      this.response_seen = false;
      this.error_seen = false;
      this.footer_hide = false;
      this.form_seen = true;
      this.confirm_seen = false;
      this.error_seen = false;
      this.spinner = false;
      this.confirm = 0;
      this.reset_error="";
    },
    async sendGatewayCommand(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();

      console.log("send command to ", this.cu, this.powerSet);
      //{ action: <nome_cmd>, payload: { cuid, cutype, plant, lampstype } }
      //1. Define Command Payloads
      const cmdData = {
        cuid: this.cu.cu_id,
        cutype: this.cu.cu_type,
        // serial: this.cu.cu_id,
        // type: this.cu.cu_type,
        command: this.powerSet,
        zone:this.cu.zone,
        interval:5
      };
      const dimmingCmd = {
        action: 'gatewayDimmingCommand',
        payload: cmdData
      };
      await this.$store.dispatch('sendGatewayCommand', dimmingCmd);

       // Hide the modal manually
       this.$nextTick(() => {
        //this.$refs.modal.hide();
      });
  
    },

    TimeoutTimer() {
      if (this.timerTimeout > 0) {
        setTimeout(() => {
          this.timerTimeout -= 1;
          console.log(this.timerTimeout);
          this.TimeoutTimer();
        }, 1000);
      }
    },
  },
};
</script>
